<!--
 * @Author: 孙培国
 * @Date: 2024-08-06 15:55:49
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-03-03 13:16:14
 * @FilePath: \new-adminproject-frontend-h5\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style lang="less">
// .van-tabbar__placeholder {
//   display: none;
//   height: 0;
// }

html,
body,
#app {
  height: 100%;
  width: 100%;
  position: relative;
  // 清除横向滚动
  overflow-x: hidden;
}

.layout-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 5px;
}
</style>
